// constants
import { showSuccessAlert } from "../../constants/alerts";
import { EnqActionTypes } from "./constants";

const INIT_STATE = {
  enqs: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface enqData {
  name: string;
  id: string;
  email: string;
  message: string;
}

interface CategoryActionType {
  type:
    | EnqActionTypes.API_RESPONSE_SUCCESS
    | EnqActionTypes.API_RESPONSE_ERROR
    | EnqActionTypes.GET_ENQ
    | EnqActionTypes.DELETE_ENQ;
  payload: {
    actionType?: string;
    data?: enqData | {};
    error?: string;
    category?: [];
  };
}

interface State {
  enqs?: enqData[] | [];
  loading?: boolean;
  value?: boolean;
}

const Enquiry = (
  state: State = INIT_STATE,
  action: CategoryActionType
): any => {
  switch (action.type) {
    case EnqActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case EnqActionTypes.GET_ENQ: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            enqs: action.payload.data,
          };
        }

        case EnqActionTypes.DELETE_ENQ: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case EnqActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case EnqActionTypes.GET_ENQ: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case EnqActionTypes.DELETE_ENQ: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case EnqActionTypes.GET_ENQ:
      return { ...state, loading: true, initialLoading: true };
    case EnqActionTypes.DELETE_ENQ:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default Enquiry;
